/**
 * Données structurées des villes desservies par Mediastore Niort.
 *
 * IMPORTANT pour SEO/GEO :
 * - Chaque ville a du contenu UNIQUE (FAQ, route, parcours client) pour éviter
 *   les "doorway pages" pénalisées par Google.
 * - Distance et temps de trajet sont basés sur Google Maps (depuis 104 Rue de la Gare, Niort 79000).
 * - Slug = URL-safe (kebab-case, accents enlevés).
 */
export const CITIES = [
  {
    slug: "chauray",
    name: "Chauray",
    postalCode: "79180",
    distanceKm: 6,
    timeMinutes: 10,
    population: "7 500 habitants",
    intercommunalite: "Communauté d'Agglomération du Niortais (CAN)",
    landmark: "ZAC du Mendès France",
    accessRoad: "D744 puis D650",
    publicTransport: "Bus Tan'Lib ligne 1",
    clientStory: "De nombreux clients de Chauray viennent quotidiennement nous voir, étant à seulement 10 minutes de notre boutique. Le trajet par la D744 est direct et rapide.",
    localFaqQ: "Combien de temps pour venir de Chauray à Mediastore Niort ?",
    localFaqA: "Chauray est à seulement 6 km de notre boutique située 104 Rue de la Gare à Niort. Comptez environ 10 minutes en voiture par la D744. Le bus Tan'Lib ligne 1 dessert également la zone et s'arrête à proximité de la gare SNCF de Niort.",
  },
  {
    slug: "aiffres",
    name: "Aiffres",
    postalCode: "79230",
    distanceKm: 7,
    timeMinutes: 12,
    population: "5 800 habitants",
    intercommunalite: "Communauté d'Agglomération du Niortais (CAN)",
    landmark: "Centre-bourg",
    accessRoad: "D740",
    publicTransport: "Bus Tan'Lib ligne 3",
    clientStory: "Les habitants d'Aiffres apprécient notre proximité (12 minutes en voiture) et notre service Click & Collect qui permet de déposer l'appareil et de le récupérer le même jour.",
    localFaqQ: "Réparez-vous les iPhone pour les habitants d'Aiffres ?",
    localFaqA: "Bien sûr ! Mediastore Niort est à seulement 7 km du centre d'Aiffres. De nombreux habitants d'Aiffres nous font confiance pour la réparation de leurs iPhone, Mac et téléphones Android. Trajet : 12 minutes par la D740. Click & Collect disponible pour gagner du temps.",
  },
  {
    slug: "bessines",
    name: "Bessines",
    postalCode: "79000",
    distanceKm: 4,
    timeMinutes: 8,
    population: "1 800 habitants",
    intercommunalite: "Communauté d'Agglomération du Niortais (CAN)",
    landmark: "Zone d'activités du Luc",
    accessRoad: "D611 (axe Niort-La Rochelle)",
    publicTransport: "Bus Tan'Lib ligne 7 (arrêt mairie Bessines)",
    clientStory: "Commune limitrophe de Niort, Bessines est à 8 minutes de Mediastore. Beaucoup de salariés des zones d'activités du Luc et de l'Aérodrome y résident et passent en boutique sur leur pause déjeuner.",
    localFaqQ: "Mediastore intervient-il pour les entreprises de Bessines ?",
    localFaqA: "Oui, Mediastore propose un service professionnel B2B pour les entreprises de Bessines (zones d'activités du Luc, de l'Aérodrome, Saint-Liguaire). Devis sur site sous 24 h pour les flottes de smartphones, ordinateurs et tablettes. Trajet de seulement 4 km via la D611.",
  },
  {
    slug: "magne",
    name: "Magné",
    postalCode: "79460",
    distanceKm: 8,
    timeMinutes: 12,
    population: "3 100 habitants",
    intercommunalite: "Communauté d'Agglomération du Niortais (CAN)",
    landmark: "Parc Naturel du Marais Poitevin",
    accessRoad: "D9",
    publicTransport: "Bus Tan'Lib ligne 5",
    clientStory: "Située au cœur du Marais Poitevin, Magné est à 12 minutes de notre atelier. Nous accueillons régulièrement des habitants venus pour réparer un iPhone tombé dans l'eau lors d'une promenade en barque.",
    localFaqQ: "Mon iPhone est tombé dans le Marais Poitevin, est-ce réparable ?",
    localFaqA: "Oui, dans la majorité des cas ! Apportez votre iPhone immédiatement à Mediastore Niort (8 km de Magné, 12 minutes par la D9), surtout SANS l'allumer. Notre service de désoxydation démarre à 69 €. Plus vous intervenez vite, plus les chances de récupération sont élevées (idéalement dans les 24 h).",
  },
  {
    slug: "echire",
    name: "Echiré",
    postalCode: "79410",
    distanceKm: 9,
    timeMinutes: 14,
    population: "3 400 habitants",
    intercommunalite: "Communauté d'Agglomération du Niortais (CAN)",
    landmark: "Beurre AOC d'Échiré",
    accessRoad: "D743",
    publicTransport: "Bus Tan'Lib ligne 4",
    clientStory: "Échiré, célèbre pour son beurre AOC, est à 14 minutes de notre boutique. Beaucoup de nos clients d'Échiré profitent d'une visite à Niort pour déposer leur appareil et faire leurs courses au centre-ville.",
    localFaqQ: "Quel itinéraire prendre depuis Échiré pour venir à Mediastore Niort ?",
    localFaqA: "Depuis Échiré, prenez la D743 direction Niort. Comptez 14 minutes pour parcourir les 9 km. Mediastore Niort est situé 104 Rue de la Gare, à proximité immédiate de la gare SNCF — parking gratuit à proximité.",
  },
  {
    slug: "la-creche",
    name: "La Crèche",
    postalCode: "79260",
    distanceKm: 12,
    timeMinutes: 15,
    population: "5 700 habitants",
    intercommunalite: "Communauté d'Agglomération du Niortais (CAN)",
    landmark: "Zone industrielle Atlansèvre",
    accessRoad: "D611 (ex-RN11) ou A10",
    publicTransport: "Bus Tan'Lib ligne 2",
    clientStory: "La Crèche, avec sa zone industrielle Atlansèvre, est un de nos principaux bassins de clientèle B2B. Nos contrats de maintenance informatique couvrent plusieurs entreprises locales.",
    localFaqQ: "Proposez-vous des contrats de maintenance informatique pour les entreprises de La Crèche ?",
    localFaqA: "Oui. Mediastore Niort intervient régulièrement chez les entreprises de la zone industrielle Atlansèvre à La Crèche (12 km, 15 minutes par la D611). Nos contrats de maintenance préventive démarrent à 59 € HT/poste/mois. Intervention sur site possible.",
  },
  {
    slug: "frontenay-rohan-rohan",
    name: "Frontenay-Rohan-Rohan",
    postalCode: "79270",
    distanceKm: 15,
    timeMinutes: 18,
    population: "3 200 habitants",
    intercommunalite: "Communauté d'Agglomération du Niortais (CAN)",
    landmark: "Château de Rohan",
    accessRoad: "D650",
    publicTransport: "Bus Tan'Lib ligne 6",
    clientStory: "Frontenay-Rohan-Rohan est à 18 minutes de notre boutique. Beaucoup d'habitants utilisent notre service Click & Collect pour éviter plusieurs aller-retours.",
    localFaqQ: "Peut-on déposer un appareil à Niort depuis Frontenay-Rohan-Rohan en une seule visite ?",
    localFaqA: "Oui, c'est exactement pour ça que nous proposons le Click & Collect. Réservez en ligne, déposez votre appareil chez nous (15 km, 18 min par la D650). Pour les pannes courantes (écran, batterie), récupération possible dans la journée. Sinon, expédition par Colissimo (gratuit > 49 €).",
  },
  {
    slug: "mauze-sur-le-mignon",
    name: "Mauzé-sur-le-Mignon",
    postalCode: "79210",
    distanceKm: 23,
    timeMinutes: 25,
    population: "2 700 habitants",
    intercommunalite: "Communauté de Communes Val de Sèvre",
    landmark: "Maison René-Caillié",
    accessRoad: "D911",
    publicTransport: "Ligne SNCF Niort-La Rochelle",
    clientStory: "Mauzé-sur-le-Mignon est sur la ligne SNCF Niort-La Rochelle. Plusieurs clients nous rejoignent en train (8 minutes de trajet) avant de marcher jusqu'à notre boutique située en face de la gare de Niort.",
    localFaqQ: "Peut-on venir à Mediastore Niort en train depuis Mauzé-sur-le-Mignon ?",
    localFaqA: "Idéal en train ! Mediastore est situé 104 Rue de la Gare à Niort, à 200 m de la gare SNCF. Trajet TER Mauzé-Niort en 8 minutes. Plusieurs trains/jour. En voiture : 23 km, 25 min par la D911.",
  },
  {
    slug: "saint-maixent-l-ecole",
    name: "Saint-Maixent-l'École",
    postalCode: "79400",
    distanceKm: 24,
    timeMinutes: 25,
    population: "6 600 habitants",
    intercommunalite: "Communauté de Communes Haut Val de Sèvre",
    landmark: "École Militaire des Sous-Officiers (ENSOA)",
    accessRoad: "N11 ou A10",
    publicTransport: "Ligne SNCF Niort-Poitiers",
    clientStory: "Saint-Maixent-l'École, ville militaire avec l'ENSOA, génère beaucoup de demandes de réparation rapide de smartphones et d'ordinateurs. Notre service Click & Collect avec expédition Colissimo est apprécié des sous-officiers en formation.",
    localFaqQ: "Réparez-vous les téléphones des élèves militaires de l'ENSOA de Saint-Maixent ?",
    localFaqA: "Oui régulièrement. Mediastore Niort accueille de nombreux militaires de l'ENSOA. Distance : 24 km, 25 min par la N11. Pour les emplois du temps chargés, nous proposons le Click & Collect avec expédition Colissimo gratuite au-delà de 49 €, et le suivi en ligne par code MC-XXXX.",
  },
  {
    slug: "melle",
    name: "Melle",
    postalCode: "79500",
    distanceKm: 28,
    timeMinutes: 30,
    population: "3 500 habitants",
    intercommunalite: "Mellois en Poitou",
    landmark: "Mines d'argent des Rois Francs",
    accessRoad: "D948",
    publicTransport: "Ligne autocar Niort-Melle",
    clientStory: "Melle, riche de son patrimoine médiéval (mines d'argent), est à 30 minutes de notre atelier. Nos clients de Melle apprécient notre Click & Collect avec retrait possible dans la journée pour les pannes simples.",
    localFaqQ: "Combien de temps pour aller de Melle à Mediastore Niort ?",
    localFaqA: "Melle est à 28 km de notre boutique, soit 30 minutes en voiture par la D948. Pour optimiser le déplacement, réservez votre créneau RDV en ligne et profitez de notre Click & Collect : déposez votre appareil et récupérez-le le même jour pour les pannes courantes.",
  },
  {
    slug: "surgeres",
    name: "Surgères",
    postalCode: "17700",
    distanceKm: 35,
    timeMinutes: 35,
    population: "7 100 habitants",
    intercommunalite: "Communauté de Communes Aunis Sud",
    landmark: "École Nationale Supérieure d'Ingénieurs Agro-Industriels (ENILIA)",
    accessRoad: "N11",
    publicTransport: "Ligne SNCF Niort-La Rochelle",
    clientStory: "Surgères, en Charente-Maritime, est sur la ligne SNCF Niort-La Rochelle. Beaucoup d'étudiants de l'ENILIA viennent à Mediastore pour réparer leur smartphone ou MacBook avant les examens.",
    localFaqQ: "Réparez-vous les téléphones et MacBook des étudiants de Surgères ?",
    localFaqA: "Oui, nous accueillons régulièrement des étudiants de l'ENILIA et du lycée Émile Combes de Surgères. Distance : 35 km, 35 minutes par la N11, ou 18 minutes en TER. Tarifs étudiants sur présentation de la carte étudiante. Devis gratuit, garantie 6 mois.",
  },
  {
    slug: "parthenay",
    name: "Parthenay",
    postalCode: "79200",
    distanceKm: 41,
    timeMinutes: 40,
    population: "10 200 habitants",
    intercommunalite: "Communauté de Communes de Parthenay-Gâtine",
    landmark: "Citadelle médiévale",
    accessRoad: "D743 (ex-RN143)",
    publicTransport: "Ligne autocar Niort-Parthenay",
    clientStory: "Parthenay, ville médiévale majeure du nord Deux-Sèvres, est à 40 minutes de notre boutique. Pour cette distance, nous recommandons l'expédition Colissimo (gratuit > 49 €) avec suivi en ligne.",
    localFaqQ: "Faut-il se déplacer à Niort depuis Parthenay pour faire réparer un iPhone ?",
    localFaqA: "Pas forcément ! Mediastore Niort propose l'expédition Colissimo gratuite au-delà de 49 € de réparation pour les habitants de Parthenay (41 km). Vous envoyez votre iPhone, nous le diagnostiquons gratuitement, vous validez le devis en ligne, et nous vous le renvoyons réparé sous 48-72 h. Suivi par code MC-XXXX.",
  },
  {
    slug: "fontenay-le-comte",
    name: "Fontenay-le-Comte",
    postalCode: "85200",
    distanceKm: 40,
    timeMinutes: 40,
    population: "13 800 habitants",
    intercommunalite: "Communauté de Communes Pays de Fontenay-Vendée",
    landmark: "Château de Terre-Neuve (Rabelais)",
    accessRoad: "N148",
    publicTransport: "Ligne autocar Niort-Fontenay",
    clientStory: "Fontenay-le-Comte, ancienne capitale du Bas-Poitou en Vendée (85), est à 40 minutes par la N148. Mediastore est le réparateur Apple certifié le plus proche pour les habitants du sud-Vendée — pas d'équivalent à Fontenay même.",
    localFaqQ: "Y a-t-il un spécialiste Apple à Fontenay-le-Comte ou faut-il aller à Niort ?",
    localFaqA: "Il n'y a pas de réparateur Apple certifié à Fontenay-le-Comte. Mediastore Niort est l'option la plus proche (40 km, 40 min par la N148). Nous proposons aussi l'expédition gratuite Colissimo (> 49 €) pour les clients de Vendée sud — solution idéale pour éviter l'aller-retour.",
  },
  {
    slug: "saint-jean-d-angely",
    name: "Saint-Jean-d'Angély",
    postalCode: "17400",
    distanceKm: 47,
    timeMinutes: 45,
    population: "7 200 habitants",
    intercommunalite: "Communauté de Communes Vals de Saintonge",
    landmark: "Abbaye royale Saint-Jean-Baptiste",
    accessRoad: "A10 (sortie 34) ou N150",
    publicTransport: "Ligne autocar Niort-Saint-Jean-d'Angély",
    clientStory: "Saint-Jean-d'Angély, ancien siège de la sénéchaussée royale, est à 45 minutes par l'A10. Plusieurs clients de Saint-Jean nous expédient leur appareil par Colissimo pour éviter le déplacement.",
    localFaqQ: "Est-il rentable de venir de Saint-Jean-d'Angély à Niort pour faire réparer un Mac ?",
    localFaqA: "Pour les Mac, oui — Mediastore est l'un des rares ateliers de la région à pratiquer la micro-soudure carte mère. Distance : 47 km, 45 min par l'A10. Alternative pratique : envoi Colissimo gratuit (> 49 €), nous diagnostiquons gratuitement et établissons un devis sous 24-48 h. Main-d'œuvre Mac : 79 €/h.",
  },
  {
    slug: "marans",
    name: "Marans",
    postalCode: "17230",
    distanceKm: 50,
    timeMinutes: 50,
    population: "4 700 habitants",
    intercommunalite: "Communauté de Communes Aunis Atlantique",
    landmark: "Port du Brault",
    accessRoad: "D938",
    publicTransport: "Aucune ligne directe",
    clientStory: "Marans, à la frontière nord-est de La Rochelle, est à 50 minutes par la D938. Beaucoup de clients de Marans optent pour notre expédition Colissimo afin d'éviter le trajet.",
    localFaqQ: "Y a-t-il un réparateur Apple à Marans ou doit-on aller à La Rochelle ou Niort ?",
    localFaqA: "Marans n'a pas de spécialiste Apple. Pour Apple, Mediastore Niort (50 km, 50 min) est plus proche que La Rochelle dans certains cas, et offre l'avantage d'être Apple-certifié. Notre service Colissimo gratuit (> 49 €) reste la solution la plus pratique pour les habitants de Marans.",
  },
  {
    slug: "bressuire",
    name: "Bressuire",
    postalCode: "79300",
    distanceKm: 60,
    timeMinutes: 50,
    population: "19 000 habitants",
    intercommunalite: "Agglomération du Bocage Bressuirais",
    landmark: "Château médiéval",
    accessRoad: "A83 ou D743",
    publicTransport: "Ligne autocar Niort-Bressuire",
    clientStory: "Bressuire, sous-préfecture du nord Deux-Sèvres, est à 50 minutes par la D743 ou l'A83. Pour cette distance, notre expédition Colissimo gratuite (> 49 €) est très populaire.",
    localFaqQ: "Faut-il vraiment se déplacer à Niort depuis Bressuire pour faire réparer son téléphone ?",
    localFaqA: "Non — Mediastore Niort propose un service d'expédition Colissimo gratuit (> 49 € de réparation) pour les clients de Bressuire (60 km). Le processus : vous nous envoyez l'appareil, diagnostic gratuit sous 24 h, devis transparent, paiement en ligne, réparation, retour sous 48-72 h avec suivi par code MC-XXXX.",
  },
  {
    slug: "rochefort",
    name: "Rochefort",
    postalCode: "17300",
    distanceKm: 60,
    timeMinutes: 55,
    population: "23 700 habitants",
    intercommunalite: "Communauté d'Agglomération Rochefort Océan",
    landmark: "Corderie Royale",
    accessRoad: "N137 puis A837",
    publicTransport: "Ligne SNCF Niort-Rochefort",
    clientStory: "Rochefort, ville arsenal de Charente-Maritime, est à 55 minutes par la N137. Le TER Niort-Rochefort (35 min) est utilisé par nos clients pour des dépôts rapides.",
    localFaqQ: "Comment venir de Rochefort à Mediastore Niort ?",
    localFaqA: "Deux options. Voiture : 60 km, 55 min par la N137 puis A837. Train : TER Rochefort-Niort en 35 min, et Mediastore est à 200 m de la gare SNCF de Niort. Le Click & Collect avec expédition Colissimo gratuite (> 49 €) reste l'option la plus pratique pour cette distance.",
  },
  {
    slug: "la-rochelle",
    name: "La Rochelle",
    postalCode: "17000",
    distanceKm: 65,
    timeMinutes: 60,
    population: "76 000 habitants",
    intercommunalite: "Communauté d'Agglomération de La Rochelle",
    landmark: "Vieux Port et tours médiévales",
    accessRoad: "A10 ou N11",
    publicTransport: "Ligne SNCF directe Niort-La Rochelle",
    clientStory: "La Rochelle, préfecture de Charente-Maritime, est à 1 heure par la N11. La connexion TER directe (45 min) permet à nos clients de profiter d'une journée à Niort tout en faisant réparer leur appareil.",
    localFaqQ: "Pourquoi un Rochelais viendrait-il à Niort pour réparer son iPhone ?",
    localFaqA: "Plusieurs raisons : (1) Mediastore Niort est Apple-certifié, ce qui n'est pas le cas de tous les ateliers rochelais. (2) Nous proposons la micro-soudure Mac, service rare en région. (3) Note Google 4,6/5 (212+ avis). (4) Expédition Colissimo gratuite > 49 € pour éviter le trajet. (5) TER direct La Rochelle-Niort en 45 min.",
  },
  {
    slug: "poitiers",
    name: "Poitiers",
    postalCode: "86000",
    distanceKm: 75,
    timeMinutes: 65,
    population: "90 000 habitants",
    intercommunalite: "Grand Poitiers Communauté Urbaine",
    landmark: "Notre-Dame-la-Grande, Futuroscope",
    accessRoad: "A10 (autoroute)",
    publicTransport: "TGV/TER Niort-Poitiers",
    clientStory: "Poitiers, préfecture de la Vienne, est à 1 heure par l'A10. La ligne TGV/TER Niort-Poitiers (35 min) rend Mediastore très accessible — plusieurs Poitevins viennent pour la spécialité micro-soudure Mac introuvable dans leur ville.",
    localFaqQ: "Mediastore Niort accepte-t-il des clients depuis Poitiers ?",
    localFaqA: "Oui, régulièrement ! Beaucoup de Poitevins (75 km, 1 h par l'A10) viennent à Mediastore Niort pour notre expertise Apple et notre service de micro-soudure carte mère. Le TER Poitiers-Niort en 35 min facilite le déplacement. Sinon, notre expédition Colissimo gratuite > 49 € est très utilisée.",
  },
];

export const findCityBySlug = (slug) => CITIES.find((c) => c.slug === slug);
